import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import { isUndefined } from 'lodash';

export const attributeUnitsApi = createApi({
  reducerPath: 'attributeUnitsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getAttributeUnits: builder.query({
      query: () => ({
        url: urls.attributeUnits,
      }),
    }),
    getAttributeUnitDetail: builder.query({
      query: (unitId) => ({
        url: urls.attributeUnitDetail(unitId),
      }),
    }),
    saveAttributeUnit: builder.mutation({
      query: ({ values, id }) => {
        if (isUndefined(id)) {
          return {
            url: urls.attributeUnits,
            method: 'POST',
            data: values,
          };
        }

        return {
          url: urls.attributeUnitDetail(id),
          method: 'PATCH',
          data: values,
        };
      },
    }),
    deleteAttributeUnit: builder.mutation({
      query: (id) => ({
        url: urls.attributeUnitDetail(id),
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetAttributeUnitsQuery,
  useGetAttributeUnitDetailQuery,
  useSaveAttributeUnitMutation,
  useDeleteAttributeUnitMutation,
} = attributeUnitsApi;
